export default __webpack_public_path__ + "static/0277-f7326d27ecc16ed22f294c70631475a6.png";